import each from 'lodash/each'
import $ from 'jquery'
import pointInPolygon from 'point-in-polygon'
import toGeoJSON from '@mapbox/togeojson'
import Vue from 'vue'
import { VueSvgGauge } from 'vue-svg-gauge'

import '../../scss/service_lookup2.scss'

// const initialModel = {
//   step: 0,
//   error: _args.error,
//   addressDefaultMessage: _args.address_default_message,
//   isZipSet: args.zipset,
//   isChecking: false,
//   addresses: null,
//   selectedAddress: null,
//   house_number: null,
//   zip: args.zipset ? args.zipcode : null,
//   redirections: redirections,
//   phase_default: url,
//   params_default: params,
//   extra_fields: extra_fields
// }

new Vue({
  components: {
    VueSvgGauge,
  },

  el: '#js-service-lookup',

  template: `
    <div class="service-lookup-container">
      <form
        v-show="formVisible"
        method="post"
        action=""
        class="uk-form-stacked service-lookup-form"
        :class="{ 'is-submitted': foundAddressOptions.length > 0 }"
        @submit.prevent="handleAddressSubmit"
      >
        <div class="service-lookup-fields">
          <div class="service-lookup-fields__street" v-if="isResidential">
            <label class="uk-form-label" for="house_num">Street Number (ex. 123)</label>
            <input type="text" class="uk-input uk-form-large" name="house_num" id="house_num" v-model="input.houseNumber">
          </div>
          <div class="service-lookup-fields__zip" v-if="isResidential">
            <label class="uk-form-label" for="zip">Zip Code</label>
            <input type="text" class="uk-input uk-form-large" name="zip" id="zip" v-model="input.zip">
          </div>
          <div class="service-lookup-fields__button">
            <label class="uk-form-label">&nbsp;</label>
            <button type="submit" class="uk-button uk-button-primary uk-button-large uk-width-1-1">
              Look-up
              <div v-if="searching" uk-spinner="ratio: 0.75"></div>
            </button>
          </div>
        </div>
        <div class="uk-alert-danger" uk-alert v-if="searchError" v-html="searchError"></div>
      </form>
  
      <transition name="slide-up">
        <div class="service-lookup-address-results uk-margin" v-if="isResidential && foundAddressOptions.length && !selectedAddress">
          <p>Please select your address from the options below:</p>
          <div v-for="address in foundAddressOptions" :key="address.Id">
            <label v-if="!selectedAddress || selectedAddress.Id === address.Id">
              <input type="radio" name="chosen_address" v-model="selectedAddress" :value="address">
              {{ address.chkpoint__A_Street_Name__c }},
              {{ address.chkpoint__A_City__c }}
              {{ address.chkpoint__A_State__c }}
            </label>
          </div>
          <div uk-alert v-if="addressTroubleMessage" v-html="addressTroubleMessage"></div>
        </div>
      </transition>
  
      <div v-show="isResidential && mapVisible && selectedAddress" class="service-lookup-map">
        <div v-if="selectedAddress" class="service-lookup-chosen-address uk-margin">
          <span>
            {{ selectedAddress.chkpoint__A_Street_Name__c }},
            {{ selectedAddress.chkpoint__A_City__c }}
            {{ selectedAddress.chkpoint__A_State__c }}
          </span>
          <button
            type="button"
            class="uk-margin-left"
            uk-close
            @click="selectedAddress = null"
            aria-label="Choose different address"
          ></button>
        </div>
  
        <div v-if="selectedAddressComponents.inUse">
          <div class="uk-alert-danger" uk-alert v-html="addressInUseErrorMessage"></div>
        </div>
  
        <div v-show="!selectedAddressComponents.inUse">
          <div class="service-lookup-address-detail">
            <div
              class="uk-margin intro-text"
              v-if="fiberhood && stage && stage.lookup_results_intro"
              v-html="stage.lookup_results_intro"
            ></div>
            <div v-if="fiberhood && stage && !stage.hide_gauge" class="uk-margin gauge-wrap">
              <vue-svg-gauge
                :start-angle="-110"
                :end-angle="110"
                :value="fiberhood.submissions_submitted"
                :separator-step="0"
                :min="0"
                :max="fiberhood.submissions_needed"
                :gauge-color="[{ offset: 0, color: '#347AB0'}, { offset: 100, color: '#8CDFAD'}]"
                :scale-interval="0.1"
              >
                <div class="gauge-text">
                  <div class="gauge-text__center">
                    <span class="gauge-text__percent">{{ fiberhood.percent_complete }}%</span>
                    <span class="gauge-text__need">
                    Need <span>{{ fiberhood.submissions_remaining }}</span> more
                  </span>
                  </div>
                </div>
              </vue-svg-gauge>
            </div>
            <p class="uk-margin" v-if="stageButtonUrl && stageButtonText">
              <a class="uk-button uk-button-large uk-button-primary" :href="stageButtonUrl">
                {{ stageButtonText }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  `,

  data: {
    // Faux props:
    stageEndpoints: null,
    stageEndpointDefault: null,
    addressInUseErrorMessage: null,
    addressTroubleMessage: null,
    businessInterestPageUrl: null,
    //

    formVisible: true,
    input: {
      customerType: 'Residential',
      houseNumber: '',
      zip: '',
    },
    searching: false,
    searchError: null,
    foundAddressOptions: [],
    selectedAddress: null,
    selectedAddressComponents: {
      address: null,
      city: null,
      state: null,
      zip: null,
      lat: null,
      lng: null,
      fiberhood: {
        name: null,
        phase: null,
      },
      inUse: false,
    },
    mapVisible: false,
    fiberhood: null,
    stage: null
  },

  computed: {
    isResidential() {
      return this.input.customerType === 'Residential'
    },

    isBusiness() {
      return !this.isResidential
    },

    stageButtonUrl() {
      if (!this.selectedAddress) {
        return null
      }

      let endpoint = null
      for (let i = 0; i < this.stageEndpoints.length; i++) {
        const potentialEndpoint = this.stageEndpoints[i]
        let conditionsMet = true
        for (let z = 0; z < potentialEndpoint.conditions.length; z++) {
          const condition = potentialEndpoint.conditions[z]
          // noinspection EqualityComparisonWithCoercionJS
          conditionsMet = conditionsMet && this.selectedAddress[condition.field] == condition.value
          if (!conditionsMet) {
            break
          }
        }
        if (conditionsMet) {
          endpoint = potentialEndpoint.redirectTo
          break
        }
      }

      if (!endpoint) {
        endpoint = this.stageEndpointDefault ? this.stageEndpointDefault : null
        if (!endpoint) {
          return null
        }
      }

      try {
        const urlObj = new URL(endpoint, window.location.href)
        urlObj.searchParams.append('id', this.selectedAddress.Id)
        urlObj.searchParams.append('fiberhood', this.selectedAddressComponents.fiberhood.name)
        urlObj.searchParams.append('phase', this.selectedAddressComponents.fiberhood.phase)
        urlObj.searchParams.append('addr', this.selectedAddressComponents.address)
        urlObj.searchParams.append('city', this.selectedAddressComponents.city)
        urlObj.searchParams.append('state', this.selectedAddressComponents.state)
        urlObj.searchParams.append('zip', this.selectedAddressComponents.zip)
        return urlObj.href
      } catch {
        return null
      }
    },

    stageButtonText() {
      if (this.stage && this.stage.stage_button_text) {
        return this.stage.stage_button_text
      }
      return 'Submit Your Interest'
    }
  },

  watch: {
    selectedAddress(selectedAddress) {
      if (!selectedAddress) {
        this.hideMap()
        return
      }

      // console.log(selectedAddress)

      this.selectedAddressComponents.address = selectedAddress.chkpoint__A_Street_Name__c
      this.selectedAddressComponents.city = selectedAddress.chkpoint__A_City__c
      this.selectedAddressComponents.state = selectedAddress.chkpoint__A_State__c
      this.selectedAddressComponents.zip = selectedAddress.chkpoint__A_Zip__c
      this.selectedAddressComponents.lat = selectedAddress.chkpoint__Latitude__c
      this.selectedAddressComponents.lng = selectedAddress.chkpoint__Longitude__c
      this.selectedAddressComponents.inUse = selectedAddress.chkpoint__Address_In_Use__c
      this.selectedAddressComponents.fiberhood.name = 'chkpoint__Fiberhood__r' in selectedAddress && selectedAddress.chkpoint__Fiberhood__r
          ? selectedAddress.chkpoint__Fiberhood__r.Name
          : ''
      this.selectedAddressComponents.fiberhood.phase = selectedAddress.chkpoint__Fiberhood_Phase__c

      // const googleLoc = new google.maps.LatLng(this.selectedAddressComponents.lat, this.selectedAddressComponents.lng)
      //
      this.showMap()
      // this.map.panTo(googleLoc)
      // this.map.setZoom(this.initialZoom)
      //
      // if (this.marker) {
      //   this.marker.setPosition(googleLoc)
      // } else {
      //   this.marker = new google.maps.Marker({
      //     map: this.map,
      //     position: googleLoc,
      //     draggable: false,
      //   })
      // }

      // this.determineFiberhood()
    },
  },

  methods: {
    doAddressSearch() {
      // reset
      this.foundAddressOptions = []
      this.selectedAddress = null
      this.searchError = null
      this.searching = true

      // noinspection JSUnresolvedVariable
      return $.ajax({
        url: ajax.url,
        type: 'POST',
        dataType: 'json',
        data: {
          action: 'sf_address_lookup',
          house_number: this.input.houseNumber,
          zip: this.input.zip,
        },
      })
    },

    fetchKmlData() {
      return $.ajax({
        type: 'GET',
        url: this.kmlUrl,
        dataType: 'xml',
      })
        .done((data) => {
          const geoJson = toGeoJSON.kml(data)
          each(geoJson.features, (feature) => {
            const submissionsNeeded = parseInt(feature.properties.submissions_needed, 10)
            const submissionsSubmitted = parseInt(feature.properties.submissions_submitted, 10)

            this.fiberhoods.push({
              id: feature.properties.stage,
              name: feature.properties.name,
              polygon: feature.geometry.coordinates[0].map((coords) => {
                  return [coords[1], coords[0]]
              }),
              submissions_needed: submissionsNeeded,
              submissions_submitted: submissionsSubmitted,
              percent_complete: Math.min(100, Math.round(submissionsSubmitted / submissionsNeeded * 100)),
              submissions_remaining: Math.max(0, submissionsNeeded - submissionsSubmitted),
            })
          })
          // this.map.data.addGeoJson(geoJson)
        })
    },

    handleAddressSubmit() {
      this.doAddressSearch()
        .done((resp) => {
          if (resp.success) {
            let data = resp.data
            if (data.records && data.records.length > 0) {
              this.foundAddressOptions = data.records
            } else {
              this.searchError = "No addresses found :("
            }
          } else {
            this.searchError = resp.data
          }
          this.searching = false
        })
        .error((jqXHR, textStatus, error) => {
          this.searchError = textStatus
          this.searching = false
        })
    },

    determineFiberhood() {
      const lat = this.selectedAddressComponents.lat
      const lng = this.selectedAddressComponents.lng

      this.stage = null
      for (let i = 0; i < this.fiberhoods.length; i++) {
        const fiberhood = this.fiberhoods[i]
        // console.log(fiberhood.polygon, lat, lng, pointInPolygon([lat, lng], fiberhood.polygon));
        if (pointInPolygon([lat, lng], fiberhood.polygon)) {
          this.fiberhood = fiberhood
          this.stage = this.getStageById(fiberhood.id)
          return
        }
      }

      this.fiberhood = null
    },

    showMap() {
      this.mapVisible = true
      // this.$nextTick(() => {
      //   google.maps.event.trigger(this.map, 'resize')
      // })
    },

    hideMap() {
      this.mapVisible = false
    },

    getStageById(id) {
      const idx = this.stages.findIndex(stage => stage.stage_id === id)
      if (idx !== -1) {
        return this.stages[idx]
      }
      return null
    },
  },

  created() {
    this.marker = null
    this.fiberhoods = []
    if (window.location.href.indexOf('demo') !== -1) {
      this.input.houseNumber = '4935';
      this.input.zip = '28601';
    }

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('zip')) {
      const zip = parseInt(urlParams.get('zip'))
      if (!Number.isNaN(zip)) {
        this.input.zip = zip;
      }
    }
  },

  beforeMount() {
    this.initialZoom = JSON.parse(this.$el.getAttribute('data-zoom-level'))
    this.kmlUrl = this.$el.getAttribute('data-kml')
    this.formUrl = this.$el.getAttribute('data-form-url')
    this.stageEndpoints =
      JSON.parse(this.$el.getAttribute('data-phase-redirects'))
        .map((raw) => ({
          redirectTo: raw.chkpt_phase_page_url,
          conditions: raw.chkpt_redirect_mappings.map((condition) => ({
            field: condition.chkpt_field_api_name,
            value: condition.chkpt_field_value,
          })),
        }))
    this.stageEndpointDefault = this.$el.getAttribute('data-phase-redirect-default')
    this.addressInUseErrorMessage = this.$el.getAttribute('data-address-in-use-error-message')
    this.addressTroubleMessage = this.$el.getAttribute('data-address-trouble-message')
    this.stages = JSON.parse(this.$el.getAttribute('data-stages'))
    this.businessInterestPageUrl = this.$el.getAttribute('data-business-interest-page-url')
  },

  mounted() {
    this.$nextTick(() => {
      // const center = { lat: 36.41397898104824, lng: -81.49939522516614 }
      // this.map = new google.maps.Map(document.getElementById('map'), { zoom: this.initialZoom, center })

      // this.map.data.setStyle((feature) => {
      //   const stage = this.getStageById(feature.getProperty('stage'))
      //   return {
      //     fillColor: stage ? stage.stage_color : '#000',
      //     strokeWeight: 1
      //   }
      // })

      if (this.kmlUrl) {
        this.fetchKmlData()
      }
    })
  }
})
